import { faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CommonTable from "common/CommonTable";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllPagesList } from "services/apiService";
import { Page } from "types";
import { TextField, TablePagination, Button } from "@mui/material";

const PagesList = () => {
  const [pagesListData, setPagesListData] = useState<Page[]>([]);
  const [pageListLoading, setPageListLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const rowsPerPage = 10;

  const navigate = useNavigate();

  useEffect(() => {
    getAllPagesData();
  }, []);

  const getAllPagesData = async () => {
    setPageListLoading(true);
    try {
      const response = await getAllPagesList();
      setPageListLoading(false);
      setPagesListData(response.data);
    } catch (error) {
      setPageListLoading(false);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setPage(0);
  };

  const filteredData = pagesListData.filter((page) =>
    page.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const headers = ["S.No", "Page Name", "Slug", "Status", "View Sections"];

  const handleNavigation = (product: any) => {
    localStorage.setItem("pageid", product.id);
    localStorage.setItem("pagename", product.name);
    navigate("/pages-list/sections");
  };

  const renderRow = (product: any, index: number) => (
    <tr className="mt-2 pt-4" key={index}>
      <td>{index + 1}</td>
      <td className="">
        <div className="d-flex flex-column product_name_td">
          <span>{product.name}</span>
        </div>
      </td>
      <td className=" align-content-center" style={{ color: "grey" }}>
        {product.slug.length > 60
          ? product.slug.slice(0, 60) + "..."
          : product.slug}
      </td>
      <td className="align-content-center">
        <span
          style={{
            color: product.is_active === 1 ? "green" : "red",
            backgroundColor: product.is_active === 1 ? "#e0f7e9" : "#f8d7da",
            padding: "5px 10px",
            borderRadius: "5px",
            display: "inline-block",
          }}
        >
          {product.is_active === 1 ? "Active" : "Inactive"}
        </span>
      </td>

      <td className="align-content-center">
        <div className="d-flex justify-content-center">
          <Button onClick={() => handleNavigation(product)} type="button">
            <FontAwesomeIcon icon={faNewspaper} />
          </Button>
        </div>
      </td>
    </tr>
  );

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  return (
    <>
      <TextField
        label="Search Pages"
        variant="outlined"
        fullWidth
        onChange={handleSearch}
        value={searchTerm}
        style={{ marginBottom: "20px" }}
      />

      <CommonTable
        data={filteredData.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )}
        isLoading={pageListLoading}
        headers={headers}
        renderRow={renderRow}
      />

      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </>
  );
};

export default PagesList;
